import axios from "../api/axios";
import useAuth from "./useAuth";
import { REFRESH_TOKEN_URL } from '../store/Utility/Resource';

const useRefreshToken = () => {
    const { auth, setAuth } = useAuth();

    const refresh = async () => {

        try {
            const response = await axios.post(REFRESH_TOKEN_URL, {}, {
                headers: {
                    'Content-Type': 'application/json'
                },
                withCredentials: true
            });

            const result = response.data.data;
            
            setAuth(prevAuth => ({
                ...prevAuth, // Spread the previous auth state to preserve other values
                user: {
                    ...prevAuth.user, // Spread the user object to preserve its other properties
                    access_token: result.accessToken, // Update only the access_token
                    id: result.user.id,
                    firstName: result.user.firstName,
                    lastName: result.user.lastName,
                    roles: result.user.roles
                }
            }));

            return result.accessToken;
        } catch (err) {
            setAuth({});
            throw err;
        }
    }

    return refresh;

}

export default useRefreshToken;